import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const openServiceRecord = createAsyncThunk(
	"openServiceRecord",
	async ({ data, form }) => {
		const { assetId, vendor, serviceDate, expectedCompletion, problemDescription } = data;

		const payload = {
			vendor,
			serviceDate: serviceDate?.toISOString ? serviceDate.toISOString() : serviceDate,
			expectedCompletion: expectedCompletion?.toISOString
				? expectedCompletion.toISOString()
				: expectedCompletion,
			problemDescription,
		};

		// Route: POST /assets/:id/service  (":id" is the assetId)
		const response = await axiosHttp.post(`assets/${assetId}/service`, payload);
		form.resetFields();
		message.success("Service record opened!");
		return response.data?.data;
	}
);

const ServiceCreateSlice = createSlice({
	name: "serviceCreateSlice",
	initialState: { isLoading: false, data: null, error: null },
	extraReducers: (builder) => {
		builder.addCase(openServiceRecord.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(openServiceRecord.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(openServiceRecord.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.error;
			message.error(action.error?.message || "Failed to open service record");
		});
	},
});

export default ServiceCreateSlice.reducer;
